var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-content-tab-bar"},_vm._l((_vm.contentTabs),function(tab,tab_k){return _c('ColumnContentTab',{key:tab_k,attrs:{"text-label":_vm.dateFormat(tab.announce_at),"link":tab.link,"activiated":_vm.isActiviated(tab)},on:{"click":function($event){return _vm.contentTabOnclick(tab,tab_k)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }